<template>
    <div
        @click="onClick"
    >
        <slot></slot>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default Vue.component('SecondaryButton', {
        props: {
            onClick: {
                type: Function,
                required: true,
            },
        },
    });
</script>
